import { queryDatabaseItems } from "../../../services/database/queryDatabaseItems";
import { getIdentityId } from "../../game/util";
import { Classroom } from "../types/classroomTypes";

export async function listClassrooms() {
  const userId = await getIdentityId();
  const classes = await queryDatabaseItems<Classroom>("/classrooms", userId);
  return classes;
}
